import React, { useState, useContext, useEffect, useRef } from "react";
import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import { ReactComponent as Copy } from "../../assets/icons/copy.svg";
import { ReactComponent as CopyunSelect } from "../../assets/icons/CopyunSelect.svg";
import { NotificationContext } from "../../Context/NotificationContext";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import CouponTitleWithSearch from "../../Components/ui/CouponTitleWithSearch";
import { selectCouponStatusBackground } from "../../Data/statuses";
import AddEditCouponPopUp from "../../NewComponents/AddEditCouponPopUp";
import DeleteTeamPopUp from "../../NewComponents/DeleteTeamPopUp";
import { firestore } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";

const pageLimit = 20;

const Coupons = ({ windowSize }) => {
  const { userData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const { transitionTo } = useScreenTransition()
  const { showNotification } = useContext(NotificationContext);
  const [filterSearch, setFilterSearch] = useState("");
  const [coupons, setCoupons] = useState([]);

  const [selectedSort, setSelectedSort] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  const [filterdCoupons, setFilterdCoupons] = useState([]);
  const [deleteCouponPopUp, showDeleteCouponPopUp] = useState(false);
  const [copiedCouponId, setCopiedCouponId] = useState(null);

  const [addCouponPopUpOpen, setAddCouponPopUpOpen] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState();
  const [moreOptions, setMoreOptions] = useState("");
  const [copyIconTooltip, setCopyIconTooltip] = useState("");

  const [showCopyIcon, setShowCopyIcon] = useState("");

  const [showDetailModal, setShowDetailModal] = useState("");
  const [title, setTitle] = useState("");
  const [discription, setDiscription] = useState("");
  const [deleteIcon, showDeleteIcon] = useState(false);
  const [couponOverlayText, setcouponOverlayText] = useState("Copy Coupon Code");
  let firstLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

   useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

  useEffect(() => {
    
    const unsubscribe = firestore
      .collection("coupons")
      .orderBy("timestamp", "desc")
      .limit(pageLimit)
      .onSnapshot(
        (querySnapshot) => {
          if (firstLoad.current) {
            nextPointer.current =
              querySnapshot.docs[querySnapshot.docs.length - 1];
            firstLoad.current = false;

            setCoupons(
              querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
          } else {
            let newCoupons = [];

            querySnapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                newCoupons.push({ id: change.doc.id, ...change.doc.data() });
              }
            });

            setCoupons((c) => newCoupons.concat(c));
          }
        },
        (error) => {
          //console.log(error);
          showNotification(
            "Error",
            "There was an error loading the coupons. Please, reload the page.",
            "error"
          );
        }
      );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let filterdData = [...coupons];

    if (filterSearch) {
      filterdData = filterdData.filter((item) => {
        return (
          item.email?.includes(filterSearch.trim()) ||
          item.code?.includes(filterSearch.trim())
        );
      });
    }
    setFilterdCoupons(filterdData);
  }, [coupons, filterSearch]);

  const sortedCoupons = [...filterdCoupons].sort((a, b) => {
    if (selectedSort === "code") {
      return sortOrder === "asc"
        ? (a.code || "").localeCompare(b.code || "")
        : (b.code || "").localeCompare(a.code || "");
    } else if (selectedSort === "discount") {
      return sortOrder === "asc"
        ? (a.discount ? a.discount.toString() : "").localeCompare(
            b.discount ? b.discount.toString() : ""
          )
        : (b.discount ? b.discount.toString() : "").localeCompare(
            a.discount ? a.discount.toString() : ""
          );
    } else if (selectedSort === "uses") {
      return sortOrder === "asc"
        ? (a.uses ? a.uses.toString() : "").localeCompare(
            b.uses ? b.uses.toString() : ""
          )
        : (b.uses ? b.uses.toString() : "").localeCompare(
            a.uses ? a.uses.toString() : ""
          );
    } else if (selectedSort === "status") {
      return sortOrder === "asc"
        ? (a.active ? "active" : "").localeCompare(b.active ? "active" : "")
        : (b.active ? "active" : "").localeCompare(a.active ? "active" : "");
    }
    return 0;
  });

  const toggleSort = (column) => {
    if (selectedSort === column) {
      setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
    } else {
      setSelectedSort(column);
      setSortOrder("desc"); // Default sorting when switching columns
    }
  };

  const loadMoreCoupons = () => {
    if (nextPointer.current) {
      
      firestore
        .collection("coupons")
        .orderBy("timestamp", "desc")
        .startAfter(nextPointer.current)
        .limit(pageLimit)
        .get()
        .then((querySnapshot) => {
          nextPointer.current =
            querySnapshot.docs[querySnapshot.docs.length - 1];

          let oldCoupons = [];

          querySnapshot.forEach((doc) => {
            oldCoupons.push({ id: doc.id, ...doc.data(), status: "active" });
          });

          setCoupons((c) => c.concat(oldCoupons));
        })
        .catch((error) => {
          showNotification(
            "Error",
            "There was an error loading the coupons. Please, reload the page.",
            "error"
          );
          //console.log("Error getting documents: ", error);
        });
    }
  };

  const handleCloseAddMemberPopUp = () => {
    setAddCouponPopUpOpen(false);
  };
  const btnAddCoupon = (coupon) => {
    setTitle("Add Coupon");
    setCurrentCoupon(coupon);
    setAddCouponPopUpOpen(true);
  };
  const btnEditCoupon = (coupon) => {
    setTitle("Edit Coupon");
    setCurrentCoupon(coupon);
    setAddCouponPopUpOpen(true);
  };
  const btnActivateCoupon = (coupon) => {
    setTitle("Activate Coupon");
    setDiscription(
      "Are you sure you want to activate this coupon? All users will gain access to this coupon and its benefits."
    );
    setCurrentCoupon(coupon);
    showDeleteCouponPopUp(true);
    showDeleteIcon(false);
  };
  const btnDeactivateCoupon = (coupon) => {
    setTitle("Deactivate Coupon");
    setDiscription(
      "Are you sure you want to deactivate this coupon? This will remove access for all users, along with its benefits."
    );
    setCurrentCoupon(coupon);
    showDeleteCouponPopUp(true);
    showDeleteIcon(false);
  };
  const btnDeleteCoupon = (coupon) => {
    setTitle("Delete Coupon");
    setDiscription(
      "Are you sure you want to delete this coupon? All users will lose access to it and its benefits."
    );
    setCurrentCoupon(coupon);
    showDeleteCouponPopUp(true);
    showDeleteIcon(true);
  };

  const handleCopy = (couponId, code) => {
    if (code) {
      navigator.clipboard.writeText(code);
      setCopiedCouponId(couponId);

      setTimeout(() => {
        setCopiedCouponId(null);
      }, 3000); // Reset after 3 seconds
      setTimeout(() => {
        setCopyIconTooltip("");
        setcouponOverlayText("Copy Coupon Code");
      }, 1000); // Reset after 3 seconds
      showNotification(
        code,
        "The coupon code has been successfully copied.",
        "success"
      );
      setcouponOverlayText("Copied!");
    }
  };

  const handleChangeStatus = async () => {
      try {
        const newStatus = currentCoupon.active ? false : true;
  
        const updateData = {
          active: newStatus,
        };
  
        await firestore.collection('coupons').doc(currentCoupon.id).update(updateData)
          .then(() => {
  
            showNotification("Coupon Update", "The coupon's status has been successfully updated.", "success");
            showDeleteCouponPopUp(false);
            setCurrentCoupon(null);
          })
          .catch(error => {
            showNotification("Error", "An error ocurred changing the coupon's status. Please, try again. If it persists, contact technical support.", "error");
          })
  
      } catch (error) {
        showNotification("Error", "An error ocurred changing the coupon's status. Please, try again. If it persists, contact technical support.", "error");
      }
  
    }
  
    const handleDeleteCoupon = async () => {
      await firestore.collection('coupons').doc(currentCoupon.id).delete()
        .then(() => {
          showNotification("Coupon Deleted", "The coupon's status has been successfully updated.", "success");
          showDeleteCouponPopUp(false);
          setCurrentCoupon(null);
        })
        .catch(error => {
          showNotification("Error", "An error ocurred changing the coupon's status. Please, try again. If it persists, contact technical support.", "error");
        })
    }

  return (
    <>
      <AccountNavBar
        windowSize={windowSize}
        selectedTab="coupons"
        accountMainPadding={false}
        admin={true}
        showButton={true}
      >
        <CouponTitleWithSearch
          title="Coupons"
          placeholder="Search by Coupons Code"
          onAddMemberClick={btnAddCoupon}
          onSearch={(val) => setFilterSearch(val)}
        />

        {addCouponPopUpOpen && (
          <AddEditCouponPopUp
            iconBgColor="#FFF6EA"
            title={title}
            couponData={currentCoupon}
            onClose={handleCloseAddMemberPopUp}
          />
        )}

        {deleteCouponPopUp && (
           <PopUpModal
           title={title}
           backBtnText="Cancel"
           subText={discription}
           text={""}
           btnText={deleteIcon ? "Delete" : "Deactivate"}
           iconBgColor="#FFF6EA"
           deleteBtn={true}
           showClose
           onClose={() => showDeleteCouponPopUp(false)}
           onClick={deleteIcon ? handleDeleteCoupon : handleChangeStatus}
           onBackClick={() => showDeleteCouponPopUp(false)}
           disableBtn={false}
           >
           <DELETE />
           </PopUpModal>
        )}

        {filterdCoupons.length === 0 ? (
          <NoData type="coupons" loading={true} showBtn={false} loadingText={"coupons"}/>
        ) : (
          <div className="accountDetailsScroll">
            <table className="accountDetailsTable">
              <thead>
                <tr>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Coupon Code</p>
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Ref. Name</p>
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Ref. Email</p>
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Discount</p>
                      {selectedSort === "discount" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("discount")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("discount")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("discount")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Status</p>
                      {selectedSort === "status" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("status")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("status")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("status")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Uses</p>
                      {selectedSort === "uses" ? (
                        sortOrder === "desc" ? (
                          <SORT
                            className="sortIcon"
                            onClick={() => toggleSort("uses")}
                          />
                        ) : (
                          <SORTBLACK
                            className="sortIcon"
                            onClick={() => toggleSort("uses")}
                          />
                        )
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => toggleSort("uses")}
                        />
                      )}
                    </div>
                  </th>

                  <th></th>
                </tr>
              </thead>
              {coupons.length > 0 && (
                <tbody>
                  {sortedCoupons.map((coupon, i) => (
                    <tr key={coupon.id + i}>
                      <td
                        className="flex gap-2 min-w-[150px]"
                        onMouseOver={() => setShowCopyIcon(coupon.id)}
                        onMouseLeave={() => setShowCopyIcon("")}
                      >
                        {coupon.code &&
                          coupon.code.length > 15 &&
                          showDetailModal === coupon.id + coupon.code && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText captialLetters"
                              >
                                {coupon.code}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText captialLetters"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(coupon.id + coupon.code)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {coupon.code || "-"}
                        </p>
                        {showCopyIcon === coupon.id && (
                          <div className="relative"  
                            onMouseOver={() => {
                                setCopyIconTooltip(coupon.id);
                              }}
                              onMouseLeave={() => {
                                setCopyIconTooltip("");
                              }}
                              onClick={() =>
                                handleCopy(coupon.id, coupon.code)
                              }
                            >
                            {coupon.code && copiedCouponId === coupon.id ? (
                              <Copy />
                            ) : (
                              <CopyunSelect
                              />
                            )}
                            {copyIconTooltip === coupon.id && (
                              <div className="absolute bg-white px-1.5 py-1 text-[13px] rounded-md shadow-md min-w-max whitespace-nowrap z-50 -top-8 -left-10">
                                {couponOverlayText}
                              </div>
                            )}
                          </div>
                        )}
                      </td>

                      <td>
                        {coupon.name &&
                          coupon.name.length > 15 &&
                          showDetailModal === coupon.id + coupon.name && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText captialLetters"
                              >
                                {coupon.name}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText captialLetters"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(coupon.id + coupon.name)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {coupon.name || "-"}
                        </p>
                      </td>
                      <td>
                        {coupon.email &&
                          coupon.email.length > 15 &&
                          showDetailModal === coupon.id + coupon.email && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText"
                              >
                                {coupon.email}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(coupon.id + coupon.email)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {coupon.email || "-"}
                        </p>
                      </td>

                      <td>
                        <p className="accountDetailsText">
                          {coupon?.discount ? `${coupon.discount}%` : "-"}
                        </p>
                      </td>
                      <td>
                        <p
                          className="accountDetailsText accountDetailsStatus"
                          style={{
                            backgroundColor: coupon.active ? "#CEF3BE" : "#F0BFBE"
                          }}
                        >
                          {coupon.active ? "Active" : "Inactive"}
                        </p>
                      </td>

                      <td>
                        <p className="accountDetailsText">
                          {coupon.uses}
                        </p>
                      </td>

                      {
                        <td>
                          <div
                            className="hardCopyAddressIconWrap"
                            onClick={(e) => {
                              e.stopPropagation();
                              setMoreOptions((prev) =>
                                prev === coupon.id ? "" : coupon.id
                              );
                            }}
                            tabIndex={0}
                            onBlur={() => setMoreOptions("")}
                          >
                            {moreOptions === coupon.id ? (
                              <MORESELECTED className="hardCopyAddressIcon" />
                            ) : (
                              <MORE
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setMoreOptions((prev) =>
                                    prev === coupon.id ? "" : coupon.id
                                  );
                                }}
                              />
                            )}
                            {moreOptions === coupon.id && (
                              <div className="hardCopyAddressEditWrap">
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnEditCoupon(coupon)}
                                >
                                  Edit Coupon
                                </div>
                                {coupon.active && (
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => btnDeactivateCoupon(coupon)}
                                  >
                                    Deactivate Coupon
                                  </div>
                                )}
                                {!coupon.active && (
                                  <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => btnActivateCoupon(coupon)}
                                  >
                                    Activate Coupon
                                  </div>
                                )}

                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnDeleteCoupon(coupon)}
                                >
                                  Delete Coupon
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              )}
            </table>

            {coupons.length === 0 ? (
              <NoData type="coupons" loading={true} showBtn={false} loadingText={"coupons"} />
            ) : null}

            {coupons.length > 0 && nextPointer.current ? (
              <p
                onClick={() => loadMoreCoupons()}
                className="loadMoreQuotesButton"
              >
                Load more Coupons...
              </p>
            ) : null}
          </div>
        )}
      </AccountNavBar>
    </>
  );
};

export default Coupons;
